import React from 'react';
import Box from '@mui/material/Box';
import {Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";

export const TermsOfUse: React.FC = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                paddingTop: theme.spacing(3),
            }}
        >
            <Typography variant="h3">
                Data Axle
            </Typography>
            <Typography variant="subtitle1">
                Terms of Use page
            </Typography>
        </Box>
    );
}
